(function () {
    'use strict';

    angular.module('app.legal', ['app.core']);
})();
